<script>
  import { scale } from "svelte/transition";
  import { elasticOut, cubicOut } from "svelte/easing";

  let className;
  export { className as class };
  export let value = "";
  export let currency = "";
  export let label = "";
  export let fadeInTime;
  export let fadeOutTime;

  const symbolsCount = value.toString().length + (currency ? 1 : 0);
  const fontScale = 1 - Math.max(symbolsCount - 3, 0) * 0.08;
  const baseFontSize = 40 * fontScale;
  const svg = `
	<svg style="font-family: Poppins, Arial; font-weight: 900; text-align: center;" viewBox="0 -10 140 ${
    baseFontSize + 35 + 20
  }" xmlns="http://www.w3.org/2000/svg">

		<defs>
			<linearGradient id="big" x1="0" x2="0" y1="0" y2="100%">
				<stop stop-color="#FFFFFF" offset="45%"/>
				<stop stop-color="#FFF295" offset="45%"/>
			</linearGradient>
			<linearGradient id="small" x1="0" x2="0" y1="0" y2="100%">
				<stop stop-color="#FFFFFF" offset="55%"/>
				<stop stop-color="#FFF295" offset="55%"/>
			</linearGradient>
			<filter id="blackglow">
				<feGaussianBlur in="SourceAlpha" stdDeviation="3.5" result="DROP"></feGaussianBlur>
				<feFlood flood-color="#fff387" result="COLOR" />
				<feComposite in="COLOR" in2="DROP" operator="in" result="SHADOW" />
				<feMerge>
						<feMergeNode in="SHADOW"/>
						<feMergeNode in="SHADOW"/>
						<feMergeNode in="SourceGraphic"/>
				</feMerge>
			</filter>
		</defs>
		<text
			text-anchor="middle"
			fill="url(#small)"
			stroke="#dd610c"
			stroke-linejoin="round"
			paint-order="stroke"
			stroke-width="5"
			font-size="25"
			x="50%"
			y="${baseFontSize + 25}"
		>${label}</text>
		<text 
			text-anchor="middle"
			fill="url(#big)"
			stroke="#dd610c"
			stroke-width="${8 * fontScale}"
			stroke-linejoin="round"
			paint-order="stroke"
			font-size="${baseFontSize}"
			x="50%"
			y="${baseFontSize}"
			style="filter:url(#blackglow)"
		>${value}${currency}</text>
	</svg>
	`;
  const src = `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svg))
  )}`;
</script>

<img
  class="coin-text {className}"
  {src}
  draggable="false"
  alt="coin text: {label} {value}{currency}"
  in:scale={{ easing: elasticOut, duration: fadeInTime }}
  out:scale={{ easing: cubicOut, duration: fadeOutTime }}
/>

<style>
  .coin-text {
    font-family: "Poppins";
    font-weight: 700;
    text-align: center;
    width: 100%;
    user-select: none;
  }
</style>
